import React from "react";
import { RouteComponentProps } from "@reach/router";
import CvInfo from "./CvInfo";
import ProfileInfo from "./Info";
import AccountInfo from "./AccountInfo";
import { CandidatCreationContext } from "context/CandidatCreation";
import SuccessInfo from "./SuccessInfo";
import Header from "ui/Header/SignupTeacher";
import axios from "axios";
import { Flow, Main, Overview, TabsWapper } from "pages/Auth/style";
import ProfileInfoT from "./ProfileInfo";

interface TabProps {
  value: number;
  index: number;
  children?: React.ReactNode;

}

const Tab = ({ index, value, children }: TabProps) => {
  return (
    <>
      {
        value === index && (
          <>
            {children}
          </>
        )
      }
    </>
  )
}

const steps = [
  {
    label: 'Informations',
    index: 0
  },
  {
    label: 'Profil',
    index: 1
  },
  {
    label: 'CV',
    index: 2
  },
  {
    label: 'Compte',
    index: 3
  },
]
const Auth: React.FC<RouteComponentProps> = () => {
  const { tabValue } = React.useContext(CandidatCreationContext);

  return (
    <Main>
      <div className="row">
        <Flow className="col-md-8">
          <Header steps={steps} current={tabValue} />
          <TabsWapper className="col-md-9 mx-auto">
            <Tab value={tabValue} index={0}>
              <ProfileInfo />
            </Tab>
            <Tab value={tabValue} index={1}>
              <ProfileInfoT />
            </Tab>
            <Tab value={tabValue} index={2}>
              <CvInfo />
            </Tab>

            <Tab value={tabValue} index={3}>
              <AccountInfo />
            </Tab>
            <Tab value={tabValue} index={4}>
              <SuccessInfo />
            </Tab>
          </TabsWapper>
        </Flow>
        <Overview className="col-md-4" />
      </div>
    </Main>
  )
}

export default Auth;